import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, MessageCircle, CreditCard, Landmark, Smartphone, Banknote, Link2 } from 'lucide-react';
import { company, paymentMethods } from '../mock';

const payIcon = (icon) => {
  const map = {
    'credit-card': <CreditCard className="w-4 h-4" />,
    'bank': <Landmark className="w-4 h-4" />,
    'smartphone': <Smartphone className="w-4 h-4" />,
    'banknote': <Banknote className="w-4 h-4" />,
    'link': <Link2 className="w-4 h-4" />
  };
  return map[icon] || <CreditCard className="w-4 h-4" />;
};

export const Footer = ({ language }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0F172A] text-gray-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-11 h-11 bg-gradient-to-br from-[#D4AF37] to-[#B48E2D] rounded-sm flex items-center justify-center">
                <span className="text-white font-bold text-lg heading-font">EG</span>
              </div>
              <h3 className="text-white font-semibold text-lg heading-font">{company.short}</h3>
            </div>
            <p className="text-sm text-gray-400 mb-5 leading-relaxed font-light">
              {language === 'en'
                ? 'Your trusted partner for premium transfers and tours in Lisbon.'
                : 'O seu parceiro de confiança para transferências e tours premium em Lisboa.'}
            </p>
            <div className="flex space-x-3">
              <a href="#" aria-label="Facebook" className="w-9 h-9 bg-white/5 hover:bg-[#D4AF37] rounded-sm flex items-center justify-center transition-colors duration-300">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" aria-label="Instagram" className="w-9 h-9 bg-white/5 hover:bg-[#D4AF37] rounded-sm flex items-center justify-center transition-colors duration-300">
                <Instagram className="w-4 h-4" />
              </a>
              <a href={`https://wa.me/${company.whatsapp}`} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="w-9 h-9 bg-white/5 hover:bg-[#25D366] rounded-sm flex items-center justify-center transition-colors duration-300">
                <MessageCircle className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4 eyebrow text-[#D4AF37]">
              {language === 'en' ? 'Services' : 'Serviços'}
            </h4>
            <ul className="space-y-2 text-sm font-light">
              <li><a href="#tiers" className="hover:text-[#D4AF37] transition-colors">{language === 'en' ? 'Airport Transfers' : 'Transferências Aeroporto'}</a></li>
              <li><a href="#tours" className="hover:text-[#D4AF37] transition-colors">{language === 'en' ? 'City Tours' : 'Tours pela Cidade'}</a></li>
              <li><a href="#tours" className="hover:text-[#D4AF37] transition-colors">{language === 'en' ? 'Private Tours' : 'Tours Privados'}</a></li>
              <li><a href="#tours" className="hover:text-[#D4AF37] transition-colors">{language === 'en' ? 'Day Trips' : 'Viagens de Um Dia'}</a></li>
            </ul>
          </div>

          {/* Payment Methods */}
          <div>
            <h4 className="text-white font-semibold mb-4 eyebrow text-[#D4AF37]">
              {language === 'en' ? 'Payment' : 'Pagamento'}
            </h4>
            <ul className="space-y-2 text-sm font-light">
              {paymentMethods.map((pm) => (
                <li key={pm.id} className="flex items-center space-x-2 text-gray-400">
                  <span className="text-[#D4AF37]">{payIcon(pm.icon)}</span>
                  <span>{language === 'en' ? pm.label : pm.labelPt}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4 eyebrow text-[#D4AF37]">
              {language === 'en' ? 'Contact' : 'Contacto'}
            </h4>
            <ul className="space-y-3 text-sm font-light">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <span>{company.address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-[#D4AF37] flex-shrink-0" />
                <a href={`tel:${company.phoneRaw}`} className="hover:text-[#D4AF37] transition-colors">{company.phone}</a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-[#D4AF37] flex-shrink-0" />
                <a href={`mailto:${company.email}`} className="hover:text-[#D4AF37] transition-colors break-all">{company.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-center text-sm text-gray-400 font-light">
          <p>&copy; {currentYear} {company.name}. {language === 'en' ? 'All rights reserved.' : 'Todos os direitos reservados.'}</p>
        </div>
      </div>
    </footer>
  );
};
